import axios from 'axios';
import { storeAction } from '../storeActions.constant';
import { storeGetters } from '../storeGetters.constant';
import { storeMutation } from '../storeMutations.constant';
import { getAxiosCancelTokenSource } from '../../app.utils';
import { wrapAction } from '@/common/utils/actionLifecycle';

import { getBasicHeaders } from '../../common/utils/utils';

const sponsorPageState = {
    baseURL: process.env.VUE_APP_BASE_URL,
    sponsorLists: null,
    userProfile: null,
    canEditSponsor: false,
};

const sponsorPageMutations = {
    [storeMutation.setSponsorList]: (state, data) => {
        state.sponsorLists = data;
    },
    [storeMutation.setCanEditSponsor]: (state, data) => {
        state.canEditSponsor = data;
    },
};

const sponsorPageActions = {
    [storeAction.getSponsorsList]: wrapAction(storeAction.getSponsorsList, ({ state, commit }, communityId) => {
            const requestSource = getAxiosCancelTokenSource();
            const requestObject = {
                actionName: storeAction.getSponsorsList,
                requestSource,
            };
            commit(storeMutation.handleCancelableRequest, requestObject, { root: true });

            return axios({
                url: `${state.baseURL}communities/api/communities/${communityId}/sponsors`,
                headers: getBasicHeaders(),
                method: 'GET',
                cancelToken: requestSource.token,
            })
            .then((response) => {
                commit(storeMutation.removeCancelableRequest, storeAction.getSponsorsList, { root: true });
                commit(storeMutation.setSponsorList, response.data.sponsors);
                commit(storeMutation.setCanEditSponsor, response.data.canEdit);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.postChapterSponsor]: wrapAction(
        storeAction.postChapterSponsor,
        async ({ state, commit }, sponsors) => {
                try {
                const response = await axios({
                    url: `${state.baseURL}communities/api/communities/${sponsors.communityId}/sponsors`,
                    headers: getBasicHeaders(),
                    data: sponsors.data,
                    method: 'POST',
                });
                commit(storeMutation.setSponsorList, sponsors.data);
                return response;
            }
            catch (errResponse) {
                console.error('Error! (postChapterSponsor)', errResponse);
                throw errResponse;
            }
        },
    ),
};

const sponsorPageGetters = {
    [storeGetters.sponsorLists]: state => state.sponsorLists || [],
    [storeGetters.userProfile]: state => state.userProfile,
    [storeGetters.canEditSponsor]: state => state.canEditSponsor,
};

export default {
    namespaced: true,
    state: {
        initialState: sponsorPageState,
        ...sponsorPageState,
    },
    mutations: { ...sponsorPageMutations },
    actions: { ...sponsorPageActions },
    getters: { ...sponsorPageGetters },
};
